"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsonschema_1 = require("jsonschema");
/**
 * *******************************
 * Functions
 * *******************************
 */
/**
 * Returns a IJSONSchemaResult object
 *
 * @export
 * @param {{}} instance
 * @param {{}} schema
 * @returns {IJSONSchemaResult}
 */
function validateJSONSchema(instance, schema) {
    var v = new jsonschema_1.Validator();
    return v.validate(instance, schema);
}
exports.validateJSONSchema = validateJSONSchema;
//# sourceMappingURL=validateSchema.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys_utils/dist/validateSchema.js
// module id = 1257
// module chunks = 1